"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ui;
var redux_loop_1 = require("redux-loop");
var actions_1 = require("./actions");
var constants_1 = require("./constants");
var initialState = function () {
    return {
        navigationOpen: false,
        flashMessages: [],
    };
};
function ui(state, action) {
    if (state === void 0) { state = initialState(); }
    switch (action.type) {
        case constants_1.TOGGLE_NAVIGATION: {
            return __assign(__assign({}, state), { navigationOpen: !state.navigationOpen });
        }
        case constants_1.SHOW_FLASH_MESSAGE: {
            var payload = action.payload;
            return (0, redux_loop_1.loop)(__assign(__assign({}, state), { flashMessages: __spreadArray(__spreadArray([], state.flashMessages, true), [payload], false) }), redux_loop_1.Cmd.list([
                redux_loop_1.Cmd.setTimeout(redux_loop_1.Cmd.action((0, actions_1.removeFlash)(payload)), 5000),
            ]));
        }
        case constants_1.REMOVE_FLASH_MESSAGE: {
            var payload_1 = action.payload;
            var index = state.flashMessages.findIndex(function (flashMessage) { return flashMessage.message == payload_1.message && flashMessage.type == payload_1.type; });
            var flashMessages = state.flashMessages.slice();
            flashMessages.splice(index, 1);
            return __assign(__assign({}, state), { flashMessages: flashMessages });
        }
        default:
            return Object.assign({}, state);
    }
}
